export interface MenuItem {
  key: string
  link: string
  mLink?: string
  auth?: boolean
  locale: string
}

export interface PanelItem {
  key: string
  icon: string
  locale: string
  items: MenuItem[]
  expandable?: boolean
}

export interface NavItem {
  key: string
  title: string
  link: string
  mLink?: string
  locale: string
  icon: string
  suffix?: string
}

export const panelItems: PanelItem[] = [
  // 买币
  {
    key: 'buyCrypto',
    icon: 'icon_buyCrypto',
    locale: 'header_047',
    items: [
      // 充值
      {
        key: 'topup',
        link: 'assetManagement/topup',
        mLink: 'account/capital/recharge/selectCoin',
        auth: true,
        locale: 'hotcoinWeb_v9_TopUp',
      },
      // C2C买币
      {
        key: 'c2cTrade',
        link: 'c2c/trade',
        mLink: '/c2c/index',
        locale: 'home_v9_C2CBuyCoins',
      },
      // 信用卡买币
      {
        key: 'creditCard',
        link: 'c2c/trade/creditCardIndex',
        mLink: 'c2c/trade/creditCard',
        locale: 'creditCard_002',
      },
    ],
  },
  // 行情
  {
    key: 'market',
    icon: 'icon_market',
    locale: 'header_059',
    items: [
      // 市场行情
      {
        key: 'market',
        link: 'market',
        mLink: 'markets',
        locale: 'header_080',
      },
      // 行业数据
      {
        key: 'marketExplore',
        link: 'marketExplore/overview',
        mLink: 'markets/?tab=4',
        locale: 'hotcoinWeb_v1_2_21_IndustryData',
      },
    ],
  },
  // 交易
  {
    key: 'trade',
    icon: 'icon_trade',
    locale: 'header_048',
    items: [
      // 现货
      {
        key: 'trade',
        link: 'trade',
        mLink: 'currency/exchange',
        locale: 'header_007',
      },
      // 杠杆
      {
        key: 'marginTrade',
        link: 'margin/trade/btc_usdt',
        mLink: 'lever/exchange',
        locale: 'marginAccount_001',
      },
      // 盘前交易
      {
        key: 'preMarket',
        link: 'preMarket',
        mLink: 'preMarket/index',
        locale: 'preMarket_001',
      },
    ],
  },
  // 合约
  {
    key: 'contract',
    icon: 'icon_contract',
    locale: 'market_025',
    items: [
      // 永续合约
      {
        key: 'perpetualContract',
        link: 'contract/exchange/trade/tradeName=btcusdt?type=1',
        mLink: 'swaps/exchange?source=swaps&type=1',
        locale: 'contract_008',
      },
      // 交割合约
      {
        key: 'deliveryContract',
        link: '',
        mLink: 'swaps/exchange?source=swaps&type=2',
        locale: 'contract_372',
      },
      // 合约模拟交易
      {
        key: 'simulation',
        link: 'simulation/exchange',
        mLink: 'swapsSilumation/exchange',
        auth: true,
        locale: 'swaps_silumation_006',
      },
      // 合约跟单
      {
        key: 'chargeBack',
        link: 'chargeBack',
        locale: 'chargeback_orderBearer117',
      },
      // 合约持仓返现活动
      {
        key: 'cashback',
        link: 'activity/cashback',
        mLink: 'activity/cashback',
        locale: 'hotcoinWeb_v101122_ContractPositionCashbackActivity',
      },
    ],
  },
  // 跟单
  {
    key: 'copy',
    icon: 'icon_copy',
    locale: 'hotcoinWeb_v12_CopyContract',
    items: [],
    expandable: false,
  },
  // 理财
  {
    key: 'financial',
    icon: 'icon_financial',
    locale: 'financial_001',
    items: [
      // 理财赚币
      {
        key: 'wealthManagement',
        link: 'wealthManagement',
        mLink: 'wealthManagement/home?tab=1',
        locale: 'financial_029',
      },
      // 质押借币
      {
        key: 'pledgeBorrowMoney',
        link: 'pledgeBorrowMoney',
        locale: 'pledg_001',
      },
      // 双币理财
      {
        key: 'twoCoinsFinalcial',
        link: 'twoCoinsFinalcial',
        mLink: 'wealthManagement/home?tab=2',
        locale: 'home_v1_22_DualCurrencyInvestment',
      },
    ],
  },
  // 更多
  {
    key: 'more',
    icon: 'icon_more',
    locale: 'header_084',
    items: [
      // 好友邀请
      {
        key: 'invitation',
        link: 'user/ic',
        mLink: 'user/ic',
        auth: false,
        locale: 'header_050',
      },
      // 福利中心
      {
        key: 'benefits',
        link: 'benefitsCenter/home',
        mLink: 'welfare/center',
        locale: 'benefits_center_001',
      },
      // 支付
      {
        key: 'pay',
        link: 'pay/home',
        mLink: 'pay/index',
        auth: true,
        locale: 'accountCoinTrade_278',
      },
      // 直播
      {
        key: 'live',
        link: 'live',
        mLink: 'live',
        locale: 'hotcoinWeb_v1_22_56_LiveStreaming',
      },
      // VIP
      {
        key: 'vip',
        link: 'vip',
        mLink: 'vip/service',
        locale: 'vip_001',
      },
      // Startup
      {
        key: 'ieo',
        link: 'ieo',
        mLink: 'ieo/home',
        locale: 'header_083',
      },
      // Hotcoin学院
      {
        key: 'learn',
        link: 'learn/index',
        locale: 'learn_016',
      },
      // NFT
      {
        key: 'nft',
        link: 'nft/home',
        mLink: 'nft/home',
        locale: 'nft_igo_044',
      },
      // 研究院
      {
        key: 'research',
        link: 'learn/index/?tab=research',
        locale: 'hotcoinWeb_v1_22_502_ResearchInstitute',
      },
      // 帮助中心
      {
        key: 'support',
        link: 'support/index',
        mLink: 'support/index',
        locale: 'header_003',
      },
      // 公告中心
      {
        key: 'notice',
        link: 'support/notice',
        locale: 'support_011',
      },
      // 流星空投
      {
        key: 'starDrop',
        link: 'campaign/templateSecond/starHome',
        locale: 'hotcoinWeb_v99_MeteorAirdrop',
      },
    ],
  },
]

export const userPanelItems: PanelItem[] = [
  // 资产
  {
    key: 'assets',
    icon: 'icon_assets',
    locale: 'header_010',
    items: [
      // 现货账户
      {
        key: 'assetManagement',
        link: 'assetManagement/home',
        mLink: 'account/capital/coin',
        locale: 'coinTrade_asset_012',
      },
      // 杠杆账户
      {
        key: 'margin',
        link: 'assetManagement/margin',
        mLink: 'account/capital/lever?tabType=1',
        locale: 'marginAccount_002',
      },
      // 合约账户
      {
        key: 'swaps',
        link: 'assetManagement/swaps',
        mLink: 'account/capital/swaps',
        locale: 'header_040',
      },
      // C2C账户
      {
        key: 'c2c',
        link: 'c2c/account',
        mLink: 'account/capital/c2c',
        locale: 'header_045',
      },
      // 理财账户
      {
        key: 'financialAccount',
        link: 'assetManagement/financialAccount',
        mLink: 'account/capital/wealthManagement',
        locale: 'financial_account_088',
      },
    ],
  },
  // 订单
  {
    key: 'order',
    icon: 'icon_order',
    locale: 'header_012',
    items: [
      // 现货订单
      {
        key: 'coinTradeOrder',
        link: 'orderHome/coinTradeOrder',
        mLink: 'currency/entrustOrder',
        locale: 'coinTrade_header_021',
      },
      // 杠杆订单
      {
        key: 'leverOrder',
        link: 'orderHome/leverOrder',
        mLink: 'lever/entrustOrder?type=1',
        locale: 'header_061',
      },
      // C2C订单
      {
        key: 'c2cOrder',
        link: 'c2c/order',
        mLink: 'c2c/order/index',
        locale: 'coinTrade_header_022',
      },
      // 合约订单
      {
        key: 'contractOrder',
        link: 'orderHome/contractOrder',
        mLink: 'swaps/order',
        locale: 'coinTrade_header_023',
      },
      // 质押借币订单
      {
        key: 'ledgeBorrowMoneyRecord',
        link: 'orderHome/ledgeBorrowMoneyRecord',
        locale: 'pledg_090',
      },
      // Start up订单
      {
        key: 'ieoOrder',
        link: 'orderHome/ieoOrder',
        mLink: 'ieo/order',
        locale: 'new_ieo_001',
      },
      // 理财订单
      {
        key: 'wealthManagementRecord',
        link: 'orderHome/wealthManagementRecord',
        mLink: 'account/capital/wealthManagement/financeLog',
        locale: 'double_coin_financial_114',
      },
      // 划转记录
      {
        key: 'transferRecord',
        link: 'orderHome/transferRecord',
        mLink: 'account/totalTransfer',
        locale: 'accountCoinTrade_066',
      },
    ],
  },
]

export const userNavItems: NavItem[] = [
  {
    key: 'overView',
    title: '账户总览',
    link: 'user/overView',
    mLink: 'account/capital/overview',
    locale: 'contract_account_009',
    icon: 'icon_overview',
  },
  {
    key: 'personSetting',
    title: '账户安全',
    link: 'user/personSetting',
    mLink: 'personalCenter/accountCenter',
    locale: 'contract_account_010',
    icon: 'icon_security',
  },
  {
    key: 'home',
    title: '福利中心',
    link: 'benefitsCenter/home',
    mLink: 'welfare/center',
    locale: 'benefits_center_001',
    suffix: 'hot',
    icon: 'icon_benefits',
  },
  {
    key: 'paymentSettings',
    title: 'C2C设置',
    link: 'c2c/paymentSettings',
    mLink: 'c2c/setUp/index',
    locale: 'otcAdvertise_222',
    icon: 'icon_c2c',
  },
  {
    key: 'ic',
    title: '好友邀请',
    link: 'user/ic',
    locale: 'header_050',
    icon: 'icon_invite',
  },
  {
    key: 'apiSetting',
    title: 'API管理',
    link: 'user/apiSetting',
    locale: 'header_051',
    icon: 'icon_api',
  },
]
